<!-- <p>select-finish works!</p> -->
<div class="fabric_cont_more_option">
	<button class="close_button" (click)="closeFinisCLose()">
		<span class="material-symbols-outlined"> close </span>
	</button>
	<h2> Select Finish
		<hr>
	</h2>

	<div class="fabrics_image_cont">
		<ng-container *ngFor="let item of finishProfileMorethan4Image; let i = index;">
			<div class="innerfabrics_image_cont {{item.checked?'active':''}}"
			(mouseenter)="moreFinishDataShow(i, item)"
			(click)="moreFinishOption(i, item)">
				<button>
					<span class="material-symbols-outlined active_check">
						done
					</span>
					<img src="{{item.image}}">
				</button>
				<div class="innerfabrics_text_cont">
					<h3>
						{{item.label}}
					</h3>
					<h5>
						{{selectedCurrency | uppercase}} {{ (item.price ? item.price : 0) | currencyConverter | number: '1.0-2'}}
					</h5>
					<p>
						{{item.description}}
					</p>
				</div>
			</div>
		</ng-container>

	</div>
	<div class="button_cont">
		<p *ngIf="selectedFinish.label">{{selectedFinish.label}}</p>
		<p *ngIf="selectedFinish.price"> Total: INR {{selectedFinish.price}} </p>
		<div class="button_cont_inner">
			<!-- <button>Fabric Details</button> -->
			<button class="total_countbutton" (click)="continueFinisCLose()">Continue</button>
		</div>
	</div>
</div>

<fb-more-finish-info [chooseFinishMorePopupdata]="moreFinishData" *ngIf="moreFinishData.label || closeInfo" (closeOption)="closeInfoPopup()"></fb-more-finish-info>
<div class="overlay_pop_up_pd" (click)="closeFinisCLose()"></div>
